<div class="filter-wrapper eu-display_flex eu-column">
    <label [attr.data-cy]="'search-option-' + filter.type" *ngFor="let filter of filters" class="emd-radio-button">
        <input
            [(ngModel)]="currentFilterType"
            (ngModelChange)="onFilterOptionChange()"
            class="emd-radio-button__input"
            type="radio"
            [id]="filter.type"
            [value]="filter.type"
        />
        <div class="emd-radio-button__area"></div>
        <span class="emd-radio-button__text emd-text _color_subtle">{{ filter.label }}</span>
    </label>
</div>
